import { PriceRangeValues } from '../PriceRange/PriceRange';

export const PriceService = (setPriceRange: (param: PriceRangeValues, callback?: () => void) => void, afterChange: (price: number[]) => void) => {
    const onChangeRange = (slider: number[], priceRange: PriceRangeValues) => {
        const range = {
            input: slider.map((x) => x.toString()),
            selected: priceRange.selected,
            slider: slider,
            thresholds: priceRange.thresholds
        };

        setPriceRange(range);
    };

    const onChangeInputMin = (value: string, priceRange: PriceRangeValues) => {
        const selectedValue = Number(value);
        if (value && (isNaN(selectedValue) || selectedValue < 0)) {
            return;
        }

        let sliderMin = priceRange.slider[0];
        if (value) {
            sliderMin = priceRange.slider[1] < selectedValue ? priceRange.slider[1] : Math.max(selectedValue, priceRange.thresholds[0]);
        }

        const range = {
            input: [value, priceRange.input[1]],
            selected: priceRange.selected,
            slider: [sliderMin, priceRange.slider[1]],
            thresholds: priceRange.thresholds
        };

        setPriceRange(range, () => onAfterChange(range));
    };

    const onChangeInputMax = (value: string, priceRange: PriceRangeValues) => {
        const selectedValue = Number(value);
        if (value && (isNaN(selectedValue) || selectedValue > priceRange.thresholds[1])) {
            return;
        }

        let sliderMax = priceRange.slider[1];
        if (value) {
            sliderMax = selectedValue < priceRange.slider[0] ? priceRange.slider[1] : selectedValue;
        }

        const range = {
            input: [priceRange.input[0], value],
            selected: priceRange.selected,
            slider: [priceRange.slider[0], sliderMax],
            thresholds: priceRange.thresholds
        };

        setPriceRange(range, () => onAfterChange(range));
    };

    const onAfterChange = (priceRange: PriceRangeValues) => {
        const queryChanged = priceRange.slider[0] !== priceRange.selected[0] || priceRange.slider[1] !== priceRange.selected[1];
        const range = {
            input: priceRange.slider.map((x) => x.toString()),
            selected: [...priceRange.slider],
            slider: priceRange.slider,
            thresholds: priceRange.thresholds
        };

        setPriceRange(range);

        if (queryChanged) {
            afterChange(range.selected);
        }
    };

    return {
        onAfterChange: onAfterChange,
        onChangeInputMin: onChangeInputMin,
        onChangeInputMax: onChangeInputMax,
        onChangeRange: onChangeRange
    };
};
